// extracted by mini-css-extract-plugin
module.exports = {"primary":"#007CC0","primaryFont":"'Source Sans Pro', sans-serif"};